import { render } from "./VFMIndustryCompareChart.vue?vue&type=template&id=322222fc"
import script from "./VFMIndustryCompareChart.vue?vue&type=script&lang=js"
export * from "./VFMIndustryCompareChart.vue?vue&type=script&lang=js"

import "./VFMIndustryCompareChart.vue?vue&type=style&index=0&id=322222fc&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__